(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.factory('AppointmentService', [
        '$rootScope', 
        '$http', 
        'HelperService', 
        'SharedAgendaService', 
        'AgendaBroadcast',
        '$uibModal',
        'DayschemeService',
        'DaySchemeTime',
         AppointmentServiceFn]);

    /* main service for appointment APIs  */
    function AppointmentServiceFn(
        $rootScope, 
        $http, 
        HelperService, 
        SharedAgendaService, 
        AgendaBroadcast,
        $uibModal,
        DayschemeService,
        DaySchemeTime) {

        var baseUrl = '/api/appointments/';

        var service = {
            get: get,
            getInternalLocation: getInternalLocation,
            getByUser: getByUser,
            update: update,
            save: save,
            deleteAppointmentById: deleteAppointmentById,
            getOnlineBookings: getOnlineBookings,
            cutAndPaste: cutAndPaste,
            copy: copy,
            state: state,
            content: content,
            confirm: confirm,
            confirmAll: confirmAll,
            sendReminderMessage: sendReminderMessage,
            getAppointmentMeetingRoomUrl : getAppointmentMeetingRoomUrl,
            listByAgenda: listByAgenda,
            listDeletedByAgenda: listDeletedByAgenda,
            listUnconfirmedByAgenda: listUnconfirmedByAgenda,
            getNoShowInformation: getNoShowInformation,
            showDeleteConfirmationModal: showDeleteConfirmationModal,
            reminderMessages: reminderMessages,
            appointmentModifications:appointmentModifications,
            validateAppointment: validateAppointment,
            blockTime: blockTime,
            editTime: editTime,
            deleteUserTime: deleteUserTime,
            resendPaymentInvite: resendPaymentInvite
        };

        return service;



        /* reminder messages */
        function reminderMessages(appointmentId) {
            return $http.get(baseUrl + appointmentId + '/agendas/' + SharedAgendaService.data.currentAgenda.id + '/reminders').then(function (response) {
                return response.data;
            });
        }
        function appointmentModifications(appointmentId) {
            return $http.get('/api/agendas/' + SharedAgendaService.data.currentAgenda.id + '/appointments/' + appointmentId + '/modifications').then(function (response) {
                return response.data;
            });
        }

        function resendPaymentInvite(appointmentId, agendaId) {
            return $http.post('/api/appointments/' + appointmentId + '/agendas/' + agendaId + '/payments/invites').then(function (response) {
                return response.data;
            });
        }

        function validateAppointment(agendaId, appointmentDate, duration) {
            // "validation/{agendaId}/{appointmentDate:datetime}/{duration:int}")]
            return $http({
                url: `${baseUrl}validation/${agendaId}/${HelperService.backendDate(appointmentDate)}/${duration}`,
                method: 'GET'
            }).then(function(response) {
                return response.data;
            });
        }

        function blockTime(time) {            
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/agenda/templates/dayscheme-time-confirmation-modal.html',
                controller: 'DaySchemeTimeConfirmationModalController',
                controllerAs: 'vm',
                size: 'xs',               
                resolve: {                    
                    date: function () {
                        return time.itemDate;
                    },
                    modalData: {
                        blockTime: true,
                        deleteTime: false
                    }
                }
            });

            function addBlockedTimeToDay(day) {
                var newTime = new DaySchemeTime();
                newTime.hour = time.hour;
                newTime.minute = time.minute;
                newTime.prepareForSave(0, day);
                newTime.fK_AgendaLabel = 1;    // Globally blocked                            

                day.times.push(newTime);
            }

            // when modal is closed
            return modalInstance.result.then(function () {                
                // logic to block the time here                
                return DayschemeService
                    .getByDate(time.agenda.owner.id, time.itemDate)
                    .then(function(dayScheme) {                        
                        if (dayScheme.id === 0) {
                            addBlockedTimeToDay(dayScheme);                           
                            return DayschemeService.save(dayScheme);
                        } else {
                            var filteredTimes = dayScheme.times.filter(function(t) {                                
                                return !(t.hour === time.hour && t.minute === time.minute);
                            });

                            dayScheme.times = filteredTimes;
                            addBlockedTimeToDay(dayScheme);
                            return DayschemeService.update(dayScheme.id, dayScheme);
                        }
                    }); 

            }, function () {
                // dismissed
                return;
            });
        }

        function editTime(time) {            
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/agenda/templates/dayscheme-time-edit-modal.html',
                controller: 'DaySchemeTimeEditModalController',
                controllerAs: 'vm',
                size: 'xs',               
                resolve: {
                    modalData: {
                        date: time.itemDate,
                        agendaId: time.agendaId,
                        currentLabelId: time.agendaLabelId
                    }
                }
            });

            function addTimeToDay(day, newAgendaLabelId) {
                var newTime = new DaySchemeTime();
                newTime.hour = time.hour;
                newTime.minute = time.minute;
                newTime.prepareForSave(0, day);
                newTime.fK_AgendaLabel = newAgendaLabelId;

                day.times.push(newTime);
            }

            // when modal is closed
            return modalInstance.result.then(function (newAgendaLabelId) {                                
                return DayschemeService
                    .getByDate(time.agenda.owner.id, time.itemDate)
                    .then(function(dayScheme) {                        
                        if (dayScheme.id === 0) {
                            addTimeToDay(dayScheme, newAgendaLabelId);                           
                            return DayschemeService.save(dayScheme);
                        } else {
                            var filteredTimes = dayScheme.times.filter(function(t) {                                
                                return !(t.hour === time.hour && t.minute === time.minute);
                            });

                            dayScheme.times = filteredTimes;
                            addTimeToDay(dayScheme, newAgendaLabelId);
                            return DayschemeService.update(dayScheme.id, dayScheme);
                        }
                    }); 

            }, function () {
                // dismissed
                return;
            });
        }

        function deleteUserTime(time) {            
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/agenda/templates/dayscheme-time-confirmation-modal.html',
                controller: 'DaySchemeTimeConfirmationModalController',
                controllerAs: 'vm',
                size: 'xs',
                resolve: {
                    date: function () {
                        return time.itemDate;
                    },
                    modalData: {
                        blockTime: false,
                        deleteTime: true
                    }
                }
            });           

            // when modal is closed
            return modalInstance.result.then(function () {                                            
                return DayschemeService
                    .getByDate(time.agenda.owner.id, time.itemDate)
                    .then(function(dayScheme) {                                                
                        var filteredTimes = dayScheme.times.filter(function(t) {                                
                            return !(t.hour === time.hour && t.minute === time.minute);
                        });

                        dayScheme.times = filteredTimes;    // filter out the dayscheme time                        
                        return DayschemeService.update(dayScheme.id, dayScheme);                        
                    }); 

            }, function () {
                // dismissed
                return;
            });
        }

        /* get one item */
        function get(appId, agendaId) {
            if (agendaId === undefined || agendaId === null) { agendaId = SharedAgendaService.data.currentAgenda.id; }
            return $http.get(baseUrl + appId + '/agendas/' + agendaId).then(function (response) {
                return response.data;
            });
        }

        function getInternalLocation(appId, agendaId) {
            if (!agendaId) {
                 agendaId = SharedAgendaService.data.currentAgenda.id; 
            }

            return $http.get(`${baseUrl}${appId}/agendas/${agendaId}/location`)
                        .then(function (response) {
                return response.data;
            });
        }

        /* get appointments by user */
        function getByUser(userId, all) {
            return $http.get(baseUrl + 'users/' + userId + '/agendas/' + SharedAgendaService.data.currentAgenda.id + '/' + all).then(function (response) {
                return response.data;
            });
        }

        /* update item */
        function update(appId, item, resendMessages, recurrenceUpdate) {
            return $http({
                url: baseUrl + appId + '/agendas/' + SharedAgendaService.data.currentAgenda.id,
                method: 'PUT',
                params: {
                    resendMessages: resendMessages,
                    recurrenceUpdate: recurrenceUpdate ? recurrenceUpdate : null
                },
                data: item
            }).then(function (response) {
                return response.data;
            });
        }

        /* update state of appointment */
        function state(appointmentId, status) {
            return $http.put(baseUrl + appointmentId + '/agendas/' + SharedAgendaService.data.currentAgenda.id + "/state/" + status).then(function (response) {
                return response.data;
            });
        }

        /* update content of appointment */
        function content(appointmentId, content) {
            return $http.put(baseUrl + appointmentId + '/agendas/' + SharedAgendaService.data.currentAgenda.id + "/content", JSON.stringify(content)).then(function (response) {
                return response.data;
            });
        }

        /* get appointment meetingroom url */
        function getAppointmentMeetingRoomUrl(appointmentId, patientUrl) {
            patientUrl = !!patientUrl;
            return $http({
                url: baseUrl + appointmentId + '/agendas/' + SharedAgendaService.data.currentAgenda.id + "/videoconsulturl",
                method: 'GET',
                params: {
                    patientUrl: patientUrl
                },
            }).then(function (response) {
                return response.data;
            });
        }

        /* send confirmation messages */
        /**
         * type can be 'sms' to send an sms instead of email
         * @param appointmentId {number}
         * @param types {string[]}
         * @return {PromiseLike<string>}
         */
        function sendReminderMessage(appointmentId, types) {
            let typeQuery = '';
            if (types) {
                typeQuery = '?types=';
                typeQuery += types.join('&types=');
            }
            return $http.get(baseUrl + appointmentId + '/agendas/' + SharedAgendaService.data.currentAgenda.id + "/confirmation" + typeQuery).then(function (response) {
                return response.data;
            });
        }


        /* save item */
        function save(appointment) {
            return $http.post(baseUrl + 'agendas/' + SharedAgendaService.data.currentAgenda.id, appointment).then(function (response) {
                return response.data;
            });
        }

        /* delete item */
        function deleteAppointmentById(id, recurrenceUpdate) {
            return $http({
                url: baseUrl + id + '/agendas/' + SharedAgendaService.data.currentAgenda.id,
                method: 'DELETE',
                params: {
                    recurrenceUpdate: recurrenceUpdate ? recurrenceUpdate : null
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* get online booked appointments */
        function getOnlineBookings(agendaId, date) {
            return $http({
                url: baseUrl + 'agendas/' + agendaId + '/onlinebookings',
                method: 'GET',
                params: {
                    date: date ? HelperService.backendDate(date) : null
                }
            });
        }

        /* cut and paste an appointment */
        function cutAndPaste(appointmentId, daySchemeTimeId, fromAgendaId, toAgendaId, date, recurrenceUpdate) {
            return $http({
                url: baseUrl + 'cutandpaste/' + appointmentId + '/' + daySchemeTimeId + '/' + fromAgendaId + '/' + toAgendaId + '/' + HelperService.backendDate(date),
                method: 'POST',
                params: {
                    recurrenceUpdate: recurrenceUpdate ? recurrenceUpdate : null
                }
            }).then(function (response) { return response.data; },      // success 
                    function() { $rootScope.$broadcast(AgendaBroadcast.AbortCutCopy); }     // error
            );
        }

        /* copy */
        function copy(appointmentId, daySchemeTimeId, fromAgendaId, toAgendaId, date, recurrenceUpdate) {
            return $http({
                url: baseUrl + 'copy/' + appointmentId + '/' + daySchemeTimeId + '/' + fromAgendaId + '/' + toAgendaId + '/' + HelperService.backendDate(date),
                method: 'POST',
                params: {
                    recurrenceUpdate: recurrenceUpdate ? recurrenceUpdate : null
                }
            }).then(
                function (response) { return response.data; },      // success
                function() { $rootScope.$broadcast(AgendaBroadcast.AbortCutCopy); }     // error
            );
        }

        /* set appointment to confirmed */
        function confirm(appointmentId) {
            return $http.put(baseUrl + appointmentId + '/agendas/' + SharedAgendaService.data.currentAgenda.id + "/confirm")
                        .then(function (response) { return response.data; });
        }

        /* set all appointments of an agenda to confirmed */
        function confirmAll(deletedAppointments) {
            return $http({
                url: baseUrl + 'agendas/' + SharedAgendaService.data.currentAgenda.id + '/confirmAll',
                method: 'PUT',
                params: {
                    deletedAppointments: deletedAppointments
                }
            }).then(function (response) { return response.data; });
        }

        // list by agenda
        function listByAgenda(agendaId, startDate, endDate, appointmentStates, urgent, isPaid, isVideoconsult) {
            return $http({
                url: baseUrl + 'agendas/' + agendaId + '/' + (urgent ? urgent : false),
                method: 'GET',
                params: {
                    startDate: startDate ? HelperService.backendDate(startDate) : null,
                    endDate: endDate ? HelperService.backendDate(endDate) : null,
                    appointmentStates: appointmentStates ? appointmentStates : null,
                    isPaid: isPaid !== undefined ? isPaid : null,
                    isVideoconsult: isVideoconsult !== undefined ? isVideoconsult : null
                }
            }).then(function (response) {
                return response.data;
            });
        }


        // list deleted appointments
        function listDeletedByAgenda(agendaId, number) {
            return $http({
                url: baseUrl + 'agendas/' + agendaId + '/deleted',
                method: 'GET',
                params: {
                    number: number
                }
            }).then(function (response) {
                return response.data;
            });
        }

        // list unconfirmed appointments
        function listUnconfirmedByAgenda(agendaId, number) {
            return $http({
                url: baseUrl + 'agendas/' + agendaId + '/unconfirmed',
                method: 'GET',
                params: {
                    number: number
                }
            }).then(function (response) {
                return response.data;
            });

        }


        /* check if patient was a no-show and returns the memo */
        function getNoShowInformation(patientId) {
            return $http.get(baseUrl + 'agendas/' + SharedAgendaService.data.currentAgenda.id + '/noshowinfo/' + patientId).then(function (response) {
                return response.data;
            });
        }

        function showDeleteConfirmationModal(id, recurrenceUpdateMethod) {
            var modalInstance = HelperService.deactivatingConfirmationModal();

            return modalInstance.result.then(function () {
                return deleteAppointmentById(id, recurrenceUpdateMethod);
            }, function () {
                // dismissed
                return;
            });
        }
    }
})();